export default __webpack_public_path__ + "static/media/landing.23de8936.png";